import(/* webpackMode: "eager" */ "/app/apps/web/app/(app)/error.tsx");
